const genres = next => {
  return drupalSettings.dargaud_reco.genres
    .map(genre => {
      return {
        value: genre.tid,
        label: genre.name,
        state: "genre",
        next: next
      };
    })
    .sort(function(a, b) {
      return compareStrings(a.label, b.label);
    });
};

function compareStrings(a, b) {
  return a < b ? -1 : a > b ? 1 : 0;
}

export default [
  {
    id: 1,
    question: "Pour qui cherchez-vous un album ?",
    answers: [
      {
        value: 1,
        label: "Pour moi",
        state: "scenario",
        range: 5,
        next: 2
      },
      {
        value: 2,
        label: "Pour un proche",
        state: "scenario",
        range: 5,
        next: 30
      }
    ]
  },
  // si choix enfant, on passe sur un arbre avec une question en moins
  {
    id: 2,
    question: "Je suis un.e",
    answers: [
      {
        value: "enfant",
        label: "Enfant",
        state: "age",
        range: 5,
        next: 3
      },
      {
        value: "ado",
        label: "Ado",
        state: "age",
        range: 5,
        next: 7
      },
      {
        value: "adulte",
        label: "Adulte",
        state: "age",
        range: 5,
        next: 7
      }
    ]
  },
  {
    id: 3,
    question: "Quel âge avez-vous ?",
    answers: [
      {
        value: 3,
        label: "3 ans et +",
        state: "age",
        next: 9
      },
      {
        value: 6,
        label: "6 ans et +",
        state: "age",
        next: 9
      },
      {
        value: 9,
        label: "9 ans et +",
        state: "age",
        next: 9
      }
    ]
  },
  {
    id: 7,
    question: "J’ai envie de lire un album de...",
    classes: "question-genre",
    // appel des genres liés au back office drupal
    answers: genres(8)
  },
  // premier ecran de proposition "pour moi"
  {
    id: 8,
    question: "",
    answers: [
      {
        state: "rien"
      }
    ],
    next: 50
  },
  // premier ecran de proposition "pour moi" & enfant
  {
    id: 9,
    question: "",
    answers: [
      {
        state: "rien"
      }
    ],
    next: 51
  },
  {
    id: 50,
    question: "Je lis de la BD...",
    answers: [
      {
        value: "peu",
        label: "Un peu",
        state: "freqLecture",
        next: 60,
        offSetFreq: 5
      },
      {
        value: "beaucoup",
        label: "Beaucoup",
        state: "freqLecture",
        next: 60,
        offSetFreq: 5
      },
      {
        value: "jamais",
        label: "Pas du tout",
        state: "freqLecture",
        next: 60,
        offSetFreq: 5
      }
    ]
  },
  // je lis BD enfant (on saute partie manga/comics)
  {
    id: 51,
    question: "Je lis de la BD...",
    answers: [
      {
        value: "peu",
        label: "Un peu",
        state: "freqLecture",
        next: 70,
        offSetFreq: 5
      },
      {
        value: "beaucoup",
        label: "Beaucoup",
        state: "freqLecture",
        next: 70,
        offSetFreq: 5
      },
      {
        value: "jamais",
        label: "Pas du tout",
        state: "freqLecture",
        next: 70,
        offSetFreq: 5
      }
    ]
  },
  {
    id: 60,
    question: "Je suis plutôt...",
    answers: [
      {
        value: "bd",
        label: "Bande dessinée",
        state: "typeLecture",
        next: 70
      },
      {
        value: "manga",
        label: "Manga",
        state: "typeLecture",
        next: 71
      },
      {
        value: "comics",
        label: "Comics",
        state: "typeLecture",
        next: 73
      }
    ]
  },
  {
    id: 70,
    question: "J'ai envie...",
    answers: [
      {
        value: true,
        label: "D'une histoire complète (en 1 volume)",
        state: "oneShot",
        next: 100
      },
      {
        value: false,
        label: "De commencer une nouvelle série",
        state: "oneShot",
        next: 100
      },
      {
        value: null,
        label: "Que vous me surpreniez !",
        state: "oneShot",
        next: 100
      }
    ]
  },
  // écran changement de genre, puis résultats
  {
    id: 99,
    question: "J'ai envie de lire...",
    classes: "question-genre",
    answers: genres(100)
  },
  // dernier ecran de proposition "pour moi" manga
  {
    id: 71,
    question: "",
    answers: [
      {
        state: "rien"
      }
    ],
    next: 72,
    retourGenre: 99
  },
  {
    id: 72,
    question: "",
    answers: [
      {
        state: "rien"
      }
    ],
    next: 71,
    retourGenre: 99
  },
  // dernier ecran de proposition "pour moi" comics
  {
    id: 73,
    question: "",
    answers: [
      {
        state: "rien"
      }
    ],
    next: 74,
    retourGenre: 99
  },
  {
    id: 74,
    question: "",
    answers: [
      {
        state: "rien"
      }
    ],
    next: 73,
    retourGenre: 99
  },
  // dernier ecran de proposition "pour moi" avec bouton relance
  {
    id: 100,
    question: "",
    answers: [
      {
        state: "rien"
      }
    ],
    next: 101,
    // le bouton de retour renvoie vers l'id 99
    retourGenre: 99,
    // quand on arrive sur la page de reco, on propose 5 albums
    updateRange: 5
  },
  {
    id: 101,
    question: "",
    answers: [
      {
        state: "rien"
      }
    ],
    next: 100,
    retourGenre: 99
  },
  {
    id: 30,
    question: "Je cherche un album pour un.e",
    answers: [
      {
        value: "enfant",
        label: "Enfant",
        state: "age",
        next: 31
      },
      {
        value: "ado",
        label: "Ado",
        state: "age",
        next: 32
      },
      {
        value: "adulte",
        label: "Adulte",
        state: "age",
        next: 32
      }
    ]
  },
  {
    id: 31,
    question: "Quel âge a l'enfant ?",
    answers: [
      {
        value: 3,
        label: "3 ans et +",
        state: "age",
        next: 33
      },
      {
        value: 6,
        label: "6 ans et +",
        state: "age",
        next: 33
      },
      {
        value: 9,
        label: "9 ans et +",
        state: "age",
        next: 33
      }
    ]
  },
  //  Fréquence de lecture proche adulte / ado
  {
    id: 32,
    question: "Quelle est sa fréquence de lecture de BD ?",
    answers: [
      {
        value: "un peu",
        state: "freqLecture",
        label: "Occasionnelle",
        offSetFreq: 5,
        next: 35
      },
      {
        value: "beaucoup",
        state: "freqLecture",
        label: "Fréquente",
        offSetFreq: 5,
        next: 35
      },
      {
        value: "jamais",
        state: "freqLecture",
        label: "Rare",
        offSetFreq: 5,
        next: 35
      },
      {
        value: "default",
        state: "freqLecture",
        label: "Je ne sais pas",
        offSetFreq: 5,
        next: 35
      }
    ]
  },
  // Fréquence de lecture proche enfant
  {
    id: 33,
    question: "Quelle est sa fréquence de lecture de BD ?",
    answers: [
      {
        value: "un peu",
        state: "freqLecture",
        label: "Occasionnelle",
        offSetFreq: 5,
        next: 46
      },
      {
        value: "beaucoup",
        state: "freqLecture",
        label: "Fréquente",
        offSetFreq: 5,
        next: 46
      },
      {
        value: "jamais",
        state: "freqLecture",
        label: "Rare",
        offSetFreq: 5,
        next: 46
      },
      {
        value: "default",
        state: "freqLecture",
        label: "Je ne sais pas",
        offSetFreq: 5,
        next: 46
      }
    ]
  },
  // Type de lecture proche adulte / ado
  {
    id: 35,
    question: "Votre proche aime plutôt...",
    answers: [
      {
        value: "bd",
        state: "typeLecture",
        label: "La bande dessinée",
        next: 45
      },
      {
        value: "manga",
        state: "typeLecture",
        label: "Le manga",
        next: 171
      },
      {
        value: "comics",
        state: "typeLecture",
        label: "Le comics",
        next: 173
      }
    ]
  },
  // préférence de lecture proche ado/adulte
  {
    id: 45,
    question: "Vous pensez qu'il ou elle aimerait...",
    answers: [
      {
        value: true,
        state: "oneShot",
        label: "Lire une histoire complète (en 1 volume)",
        next: 55
      },
      {
        value: false,
        state: "oneShot",
        label: "Commencer une nouvelle série",
        next: 55
      },
      {
        value: null,
        state: "oneShot",
        label: "Je ne sais pas",
        next: 55
      }
    ]
  },
  // préférence de lecture proche enfant
  {
    id: 46,
    question: "Vous pensez qu'il ou elle aimerait...",
    answers: [
      {
        value: true,
        state: "oneShot",
        label: "Lire une histoire complète (en 1 volume)",
        next: 58
      },
      {
        value: false,
        state: "oneShot",
        label: "Commencer une nouvelle série",
        next: 58
      },
      {
        value: null,
        state: "oneShot",
        label: "Je ne sais pas",
        next: 58
      }
    ]
  },
  {
    id: 55,
    question: "Selon vous, quel est son genre préféré...",
    classes: "question-genre",
    answers: genres(58)
  },
  // ecran de proposition "pour un proche"
  {
    id: 58,
    answers: [
      {
        state: "rien"
      }
    ],
    retourGenre: 55,
    next: 59
  },
  {
    id: 59,
    answers: [
      {
        state: "rien"
      }
    ],
    retourGenre: 55,
    next: 58
  },
  // ecran de proposition "pour un proche" manga/comics
  {
    id: 171,
    answers: [
      {
        state: "rien"
      }
    ],
    retourGenre: 55,
    next: 172
  },
  {
    id: 172,
    answers: [
      {
        state: "rien"
      }
    ],
    retourGenre: 55,
    next: 171
  },
  {
    id: 173,
    answers: [
      {
        state: "rien"
      }
    ],
    retourGenre: 55,
    next: 174
  },
  {
    id: 174,
    answers: [
      {
        state: "rien"
      }
    ],
    retourGenre: 55,
    next: 173
  }
];
